var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 50,
    viewBox: "0 0 164 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-100 -386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 164,
    height: 50,
    rx: 6,
    transform: "translate(100 386)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Get_it_on",
    "data-name": "Get it on",
    transform: "translate(151 407)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.029em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GET IT ON")), /*#__PURE__*/React.createElement("text", {
    id: "Google_Play",
    "data-name": "Google Play",
    transform: "translate(151 427)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    letterSpacing: "0.029em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google Play"))), /*#__PURE__*/React.createElement("g", {
    id: "google-play",
    transform: "translate(118.163 397.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M24.372,12.6a2.27,2.27,0,0,1-1.163,1.976l-5.871,3.263L12.37,12.6,17.338,7.36l5.871,3.263A2.27,2.27,0,0,1,24.372,12.6Z",
    transform: "translate(0.885 0.314)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M13.838,13.471,1.644,26.331A2.2,2.2,0,0,1,1,24.762V2.179A2.2,2.2,0,0,1,1.644.61Z",
    transform: "translate(-0.583 -0.558)",
    fill: "#03a9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M13.764,12l4.968,5.239C3.859,25.4,3.235,26.619,1.57,24.861Z",
    transform: "translate(-0.51 0.913)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M18.732,8.31l-4.968,5.239L1.57.689A2.244,2.244,0,0,1,4.28.282Z",
    transform: "translate(-0.51 -0.637)",
    fill: "#4caf50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.8599a8bb603ba048a05e546ad08c6788.svg";
export { ForwardRef as ReactComponent };